import { render, staticRenderFns } from "./BySalesman.vue?vue&type=template&id=447f61bd&scoped=true&"
import script from "./BySalesman.vue?vue&type=script&lang=js&"
export * from "./BySalesman.vue?vue&type=script&lang=js&"
import style0 from "./BySalesman.vue?vue&type=style&index=0&id=447f61bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447f61bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
